var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLinkOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14641 3.63424C5.90856 3.22664 6.65822 3.09998 8.22787 3.09998H10.1001C10.5971 3.09998 11.0001 3.50292 11.0001 3.99998C11.0001 4.49703 10.5971 4.89998 10.1001 4.89998H8.22787C6.7412 4.89998 6.35727 5.02791 5.99528 5.2215C5.65944 5.40112 5.40124 5.65931 5.22163 5.99516C5.02804 6.35714 4.9001 6.74108 4.9001 8.22775V15.7722C4.9001 17.2589 5.02804 17.6428 5.22163 18.0048C5.40124 18.3406 5.65944 18.5988 5.99528 18.7784C6.35727 18.972 6.7412 19.1 8.22787 19.1H15.7723C17.259 19.1 17.6429 18.972 18.0049 18.7784C18.3408 18.5988 18.599 18.3406 18.7786 18.0048C18.9722 17.6428 19.1001 17.2589 19.1001 15.7722V13.9C19.1001 13.4029 19.503 13 20.0001 13C20.4972 13 20.9001 13.4029 20.9001 13.9V15.7722C20.9001 17.3419 20.7734 18.0915 20.3658 18.8537C20.0185 19.5032 19.5033 20.0183 18.8538 20.3657C18.0916 20.7733 17.342 20.9 15.7723 20.9H8.22787C6.65822 20.9 5.90856 20.7733 5.14641 20.3657C4.49687 20.0183 3.98174 19.5032 3.63436 18.8537C3.22676 18.0915 3.1001 17.3419 3.1001 15.7722V8.22775C3.1001 6.6581 3.22676 5.90843 3.63436 5.14628C3.98174 4.49675 4.49687 3.98161 5.14641 3.63424Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0001 3.99998C14.0001 3.50292 14.403 3.09998 14.9001 3.09998H20.0001C20.4972 3.09998 20.9001 3.50292 20.9001 3.99998V9.09998C20.9001 9.59703 20.4972 9.99998 20.0001 9.99998C19.5031 9.99998 19.1001 9.59703 19.1001 9.09998V6.17277L12.5365 12.7364C12.185 13.0878 11.6152 13.0878 11.2637 12.7364C10.9123 12.3849 10.9123 11.8151 11.2637 11.4636L17.8273 4.89998H14.9001C14.403 4.89998 14.0001 4.49703 14.0001 3.99998Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkOutline);
export default __webpack_public_path__ + "static/media/external_link_outline.df700c6cd039995654ca2c821e976ca3.svg";
export { ForwardRef as ReactComponent };